import type { CommendaAiConversationAccessView } from '@commenda/api/commenda-ai/types';
import { PanelHeaderActions } from '@commenda/ui/commenda-ai/PanelHeaderActions';
import { ChatPanelHistoryMenu } from 'components/chat-panel/ChatPanelHistoryMenu';

/** The shared panel header actions, with this surface's history list and its expand target. */
export const ChatPanelHeaderActions = ({
  access,
  activeConversationId,
  onStartNewConversation,
  onSelectConversation,
  onExpand,
  onClose,
}: {
  access?: CommendaAiConversationAccessView;
  activeConversationId: string | null;
  onStartNewConversation: () => void;
  onSelectConversation: (conversationId: string) => void;
  onExpand: () => void;
  onClose: () => void;
}) => (
  <PanelHeaderActions
    access={access}
    onStartNew={onStartNewConversation}
    historyMenu={
      <ChatPanelHistoryMenu
        activeConversationId={activeConversationId}
        onSelect={onSelectConversation}
      />
    }
    onExpand={onExpand}
    onClose={onClose}
  />
);
